import { requestKarangoApi } from "../../../core/api/karangoTransport";

export async function listEventBadgeTiers(eventId, { signal } = {}) {
  if (!eventId) {
    return [];
  }

  const payload = await requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/badge-tiers`,
    { signal }
  );

  return Array.isArray(payload?.tiers) ? payload.tiers : [];
}

export async function createBadgeReservationCheckout(eventId, checkoutPayload = {}) {
  if (!eventId) {
    throw new Error("eventId requis.");
  }

  return requestKarangoApi(
    `/v1/events/${encodeURIComponent(String(eventId))}/badge-reservations/checkout`,
    {
      method: "POST",
      requiresAuth: true,
      body: checkoutPayload,
    }
  );
}

export async function getBadgeReservation(reservationId, { signal } = {}) {
  if (!reservationId) {
    return null;
  }

  const payload = await requestKarangoApi(
    `/v1/badge-reservations/${encodeURIComponent(String(reservationId))}`,
    {
      requiresAuth: true,
      signal,
    }
  );

  return payload?.reservation || null;
}

export async function cancelMyBadgeReservation(reservationId) {
  if (!reservationId) throw new Error("reservationId requis.");
  const payload = await requestKarangoApi(
    `/v1/badge-reservations/${encodeURIComponent(String(reservationId))}/cancel`,
    { method: "POST", requiresAuth: true }
  );
  return payload?.reservation || null;
}

export async function listMyBadgeReservations({ limit = 50, signal } = {}) {
  const payload = await requestKarangoApi(
    `/v1/badge-reservations/mine?limit=${encodeURIComponent(String(limit))}`,
    {
      requiresAuth: true,
      signal,
    }
  );

  return Array.isArray(payload?.reservations) ? payload.reservations : [];
}

export async function refundBadgeReservationAdmin(reservationId) {
  if (!reservationId) throw new Error("reservationId requis.");
  const payload = await requestKarangoApi(
    `/v1/admin/badge-reservations/${encodeURIComponent(String(reservationId))}/refund`,
    { method: "POST", requiresAuth: true }
  );
  return payload?.reservation || null;
}

export async function listEventBadgeReservationsAdmin(
  eventId,
  { status = null, search = null, limit = 100, signal } = {}
) {
  if (!eventId) throw new Error("eventId requis.");
  const params = new URLSearchParams({ limit: String(limit) });
  if (status) params.set("status", status);
  if (search) params.set("search", search);
  const payload = await requestKarangoApi(
    `/v1/admin/events/${encodeURIComponent(String(eventId))}/badge-reservations?${params}`,
    { requiresAuth: true, signal }
  );
  return {
    reservations: Array.isArray(payload?.reservations) ? payload.reservations : [],
    stats: payload?.stats || { total: 0, reserved: 0, pending: 0, refunded: 0, totalRevenueCents: 0 },
  };
}
